/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CognitiveNormCto } from '../../models/cognitive-norm-cto';

export interface GetDemoCognitiveNormsAsync$Plain$Params {
}

export function getDemoCognitiveNormsAsync$Plain(http: HttpClient, rootUrl: string, params?: GetDemoCognitiveNormsAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CognitiveNormCto>>> {
  const rb = new RequestBuilder(rootUrl, getDemoCognitiveNormsAsync$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CognitiveNormCto>>;
    })
  );
}

getDemoCognitiveNormsAsync$Plain.PATH = '/demo-account-data/cognitive-norms';
